import PropTypes from 'prop-types'
import {
  NotFoundHeader,
  NotFoundContainer,
  NotFoundDescription,
  NotFoundIcon
} from './styled-components'
import { NotFound } from '../../atoms/icons/core'
import { textStyleSizeOptions } from '../../fundamentals/text-styles/constants'

const NotFoundComponent = ({
  icon = null,
  header,
  description,
  headerSize = textStyleSizeOptions['TEXT-XL'],
  descriptionSize = textStyleSizeOptions['TEXT-R'],
  ...props
}) => {
  const defineIcon = icon ?? (
    <NotFound style={{ width: '144px', height: '144px' }} />
  )
  return (
    <NotFoundContainer {...props}>
      <NotFoundIcon>{defineIcon}</NotFoundIcon>
      <NotFoundHeader size={headerSize}>{header}</NotFoundHeader>
      <NotFoundDescription size={descriptionSize}>
        {description}
      </NotFoundDescription>
    </NotFoundContainer>
  )
}

NotFoundComponent.propTypes = {
  icon: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  headerSize: PropTypes.oneOf(Object.keys(textStyleSizeOptions)),
  descriptionSize: PropTypes.oneOf(Object.keys(textStyleSizeOptions))
}

export default NotFoundComponent
